import { PostCardProps } from "../../../types/types";

import { ChallengePost, EventPost, ProgramPost, ServicePost } from "../../../types/post.type";

import { BasicPost } from "../../../types/types";
import { PostTypeEnum } from "../../../enums/post.enum";

import EventPostCard from "./EventPostCard";
import ServicePostCard from "./ServicePostCard";
import ProgramPostCard from "./ProgramPostCard";
import ChallengePostCard from "./ChallengePostCard";
import BasicPostCard from "./BasicPostCard/BasicPostCard";

const PostContent = ({ post, onClickOnMedia }: PostCardProps) => {
  switch (post.postType) {
    case PostTypeEnum.EVENT:
      return <EventPostCard post={post as EventPost} />;
    case PostTypeEnum.BASIC:
      return <BasicPostCard post={post as BasicPost} onClickOnMedia={onClickOnMedia} />;
    case PostTypeEnum.SERVICE:
      return <ServicePostCard post={post as ServicePost} />;
    case PostTypeEnum.PROGRAM:
      return <ProgramPostCard post={post as ProgramPost} />;
    case PostTypeEnum.CHALLENGE:
      return <ChallengePostCard post={post as ChallengePost} handlePlayClick={onClickOnMedia} />;
    default:
      return <></>;
  }
};

export default PostContent;
